export const PAGE_NAME = 'customerService';
export const HELP_CENTER_LINK = 'https://help.yfanqie.com/';
// 七鱼管理端网心云对应的appkey
export const QIYU_ONETHING_APP_KEY = '778c6386b4234e63fac82ef2048a3e2c';
// 七鱼管理端网心云对应的appSecret
export const QIYU_ONETHING_APP_SECRET = '205FFCBEDCF541D9A650BF89FD38F700';
// 非登录客服模板
export const UNLOGIN_TEMPLATE_ID = 6656873;
// 非登录referrer
export const UNLOGIN_REFERRER = 'https://www.onethingcloud.com/customer-service/';
// 登录客服模板
export const LOGINED_TEMPLATE_ID = 6657004;
// 登录referrer
export const LOGINED_REFERRER = 'https://h5-box.onethingpcs.com/customerService';
// 客服中心-帮助中心
export const TO_HELP_CENTER = 'helpCenter';
// 客服中心-产品咨询
export const TO_PRODUCT = 'product';
// 客服中心-设备保障
export const TO_DEVICE_TOOL = 'deviceTool';

export const SERVICE_MENU_LIST = [
  {
    type: TO_HELP_CENTER,
    title: '万能宝典',
    desc: '99%的问题在这里都可以找到答案',
  },
  {
    type: TO_PRODUCT,
    title: '上机咨询',
    desc: '新手上机，网络配置咨询，产品、活动、定向业务咨询',
  },
  {
    type: TO_DEVICE_TOOL,
    title: '异常问题处理',
    desc: '账号解/换绑、实名等，设备0/低收益、设备工单报障等，发票问题、提现异常等',
  },
];

// 七鱼环境变量
export const QIYU_ENV = 'online';
